import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';
import { removecart } from '../../utils/byoscart';
import store, { CART_COUNT_UPDATE } from '../../utils/store';

import { message } from 'antd';
import { NotificationContainer, NotificationManager } from 'react-notifications';

class Checkout extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wishlist: [],
            totalBox: [],
            addressList: [],
            gst_number: '',
            deliveryaddress: '',
            selectedAddress: {},
            serviceCheck: false,
        };
        this.openPayModal = this.openPayModal.bind(this);
        this.updateOrderStatus = this.updateOrderStatus.bind(this);
    }

    async componentDidMount() {
        this.loadCart();

        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/addressList', params);
            const resVal = response.data;
            if (resVal.status === 'success') {
                const addressList = Array.isArray(resVal.data) ? resVal.data : [];
                const defaultAddress = addressList.length > 0 ? addressList[0] : {};
                this.setState({
                    addressList,
                    deliveryaddress: defaultAddress.address_id ? `${defaultAddress.address_id}` : '',
                    selectedAddress: defaultAddress,
                });
            } else {
                NotificationManager.error(resVal.message);
            }
        } catch (error) {
            console.error(error);
        }

        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
    }

    async loadCart() {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/cartList', params);
            const resVal = response.data;
            if (resVal.status === 'success') {
                this.setState({
                    wishlist: resVal.data,
                    totalBox: resVal.totalAmount,
                    serviceCheck: true,
                });
            }
        } catch (error) {
            this.setState({ serviceCheck: true });
            console.error(error);
        }
    }

    localremovewishlist(variation_id) {
        removecart(variation_id);
        this.loadCart();
    }

    async updateCart(typeVal, variation_id, quantity = 0) {
        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        params.append('type', typeVal);
        params.append('id', variation_id);
        params.append('quantity', quantity);
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/updateCart', params);
            const resVal = response.data;
            if (resVal.status === 'success') {
                this.loadCart();
                message.success({
                    content: resVal.message,
                    className: 'notificationBox',
                });
            }
        } catch (error) {
            this.setState({ serviceCheck: true });
            console.error(error);
        }
    }

    updateDeliveryAddress(addressId) {
        const selectedAddress = this.state.addressList.find((address) => `${address.address_id}` === `${addressId}`) || {};
        this.setState({
            deliveryaddress: `${addressId}`,
            selectedAddress,
        });
    }

    async openPayModal() {
        if (this.state.totalBox.total_cart_value > 0) {
            const options = {
                key: 'rzp_test_TSjubDe9XDYte6',
                amount: this.state.totalBox.total_cart_value * 100,
                name: "Natureway",
                description: "Online purchase",
                order_id: "",
                handler: function (response) {
                    this.updateOrderStatus(response);
                }.bind(this),
                prefill: {
                    name: this.state.totalBox.customer_name,
                    email: this.state.totalBox.customer_email,
                    contact: this.state.totalBox.customer_mobile,
                },
                notes: {
                    byos_order_code: this.state.totalBox.order_id,
                    byos_order_amount: this.state.totalBox.total_cart_value
                },
                theme: {
                    color: "#528ff0"
                }
            };

            const params = new URLSearchParams();
            params.append('token', localStorage.getItem('byos_token'));
            params.append('order_id', this.state.totalBox.order_id);
            params.append('amount', this.state.totalBox.total_cart_value);
            params.append('delivery_address', this.state.deliveryaddress);
            params.append('gst_number', this.state.gst_number);
            try {
                const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/createOrder', params);
                const resVal = response.data;
                if (resVal.status === 'success') {
                    options.order_id = resVal.data;
                    const rzp1 = new window.Razorpay(options);
                    rzp1.open();
                }
            } catch (error) {
                this.setState({ serviceCheck: true });
                console.error(error);
            }
        }
    }

    async updateOrderStatus(response) {
        store.dispatch({ type: CART_COUNT_UPDATE, value: 0 });

        const params = new URLSearchParams();
        params.append('token', localStorage.getItem('byos_token'));
        params.append('razorpay_signature', response.razorpay_signature);
        params.append('razorpay_order_id', response.razorpay_order_id);
        params.append('transactionid', response.razorpay_payment_id);
        params.append('order_id', this.state.totalBox.order_id);
        params.append('order_amount', this.state.totalBox.total_cart_value);
        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/confirmOrder', params);
            const resVal = response.data;
            if (resVal.status === 'success') {
                message.success({
                    content: resVal.message,
                    className: 'notificationBox',
                });
                this.props.history.push('/orderpreview');
            } else {
                message.error({
                    content: resVal.message,
                    className: 'notificationBox',
                });
            }
        } catch (error) {
            console.error(error);
        }
    }

    render() {
        const { totalBox, deliveryaddress, selectedAddress } = this.state;

        const selectedAddressType = selectedAddress.user_address_type === 'W' ? 'Work' : 'Home';
        const selectedAddressLine = [
            selectedAddress.user_address,
            selectedAddress.user_locality,
            selectedAddress.user_city,
            selectedAddress.user_state,
            selectedAddress.user_pincode,
        ].filter(Boolean).join(', ');

        return (
            <div className="ps-checkout">
                <div className="ps-categogy ps-categogy--separate">
                    <div className="container whiteContainer">
                        <div className="row">
                            <div className="col-12">
                                <ul className="ps-breadcrumb">
                                    <li className="ps-breadcrumb__item"><Link to="/cart">Cart</Link></li>
                                    <li className="ps-breadcrumb__item active"><span>Checkout</span></li>
                                </ul>
                            </div>

                            <div className="col-12">
                                {this.state.wishlist.length > 0 ? (
                                    <div className="ps-checkout__layout">
                                        <div className="ps-checkout__main">
                                            <section className="ps-checkout-card">
                                                <div className="ps-checkout-card__header">
                                                    <div>
                                                        <span className="ps-checkout-card__eyebrow">Delivery address</span>
                                                        <h3>Select a saved address</h3>
                                                        <p>Pick one address from the dropdown and we will fill the delivery details automatically.</p>
                                                    </div>
                                                    <div className="ps-checkout-card__count">{this.state.addressList.length} saved</div>
                                                </div>

                                                <div className="ps-checkout-card__body">
                                                    {this.state.addressList.length > 0 ? (
                                                        <>
                                                            <label className="ps-checkout-card__label" htmlFor="checkoutAddressSelect">
                                                                Delivery address
                                                            </label>
                                                            <select
                                                                id="checkoutAddressSelect"
                                                                className="form-control ps-checkout-card__select"
                                                                value={deliveryaddress}
                                                                onChange={(event) => this.updateDeliveryAddress(event.target.value)}
                                                            >
                                                                <option value="">Select a saved address</option>
                                                                {this.state.addressList.map((data) => (
                                                                    <option key={data.address_id} value={data.address_id}>
                                                                        {data.user_name} - {data.user_city}, {data.user_pincode}
                                                                    </option>
                                                                ))}
                                                            </select>

                                                            {deliveryaddress ? (
                                                                <div className="ps-checkout-card__preview">
                                                                    <div className="ps-checkout-card__previewHeader">
                                                                        <div>
                                                                            <span className="ps-checkout-card__previewName">{selectedAddress.user_name}</span>
                                                                            <p className="ps-checkout-card__previewMeta">
                                                                                {selectedAddress.user_mobile}
                                                                                <span className="ps-checkout-card__badge">{selectedAddressType}</span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <p className="ps-checkout-card__previewAddress">{selectedAddressLine}</p>
                                                                    {selectedAddress.user_landmark ? (
                                                                        <p className="ps-checkout-card__previewHint">Landmark: {selectedAddress.user_landmark}</p>
                                                                    ) : null}
                                                                </div>
                                                            ) : (
                                                                <div className="ps-checkout-card__empty">
                                                                    Pick an address to view the delivery details here.
                                                                </div>
                                                            )}

                                                            <div className="ps-checkout-card__footer">
                                                                <span className="ps-checkout-card__footerText">Need a different address?</span>
                                                                <Link to="/address" className="ps-checkout-card__link">Add or edit addresses</Link>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <div className="ps-checkout-card__empty">
                                                            No saved address found. Please add one before continuing.
                                                            <div className="ps-checkout-card__footer ps-checkout-card__footer--stacked">
                                                                <Link to="/address" className="ps-checkout-card__link">Add new address</Link>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </section>

                                            <section className="ps-checkout-card ps-checkout-card--table">
                                                <div className="ps-checkout-card__header">
                                                    <div>
                                                        <span className="ps-checkout-card__eyebrow">Order items</span>
                                                        <h3>Review your cart</h3>
                                                    </div>
                                                </div>

                                                <div className="ps-checkout-tableWrap">
                                                    <table className="table ps-table ps-table--product byosCustomCart">
                                                        <thead>
                                                            <tr>
                                                                <th className="ps-product__thumbnail">Preview</th>
                                                                <th className="ps-product__name">Product name</th>
                                                                <th className="ps-product__meta">Unit price</th>
                                                                <th className="ps-product__meta" align="center">Quantity</th>
                                                                <th className="ps-product__meta">Total</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.wishlist.map((product_details) => {
                                                                return (
                                                                    <tr key={product_details.cart_id || product_details.variation_id}>
                                                                        <td className="ps-product__thumbnail">
                                                                            <div className="ps-product__image">
                                                                                {product_details.display_image !== '' ?
                                                                                    <figure>
                                                                                        <img src={product_details.display_image} alt={product_details.product_name} />
                                                                                    </figure>
                                                                                    :
                                                                                    <figure>
                                                                                        <img src='/assets/img/byos-no-image.png' alt="No product" />
                                                                                    </figure>
                                                                                }
                                                                            </div>
                                                                        </td>
                                                                        <td className="ps-product__name">
                                                                            {product_details.product_name}
                                                                        </td>
                                                                        <td className="ps-product__meta">
                                                                            <span className="ps-product__price sale">&#8377;{product_details.offer_price}</span>
                                                                            <span className="ps-product__del">&#8377;{product_details.selling_price}</span>
                                                                        </td>
                                                                        <td className="ps-product__meta">
                                                                            <span>{product_details.quantity}</span>
                                                                        </td>
                                                                        <td className="ps-product__meta">
                                                                            <span className="ps-product__price sale">&#8377;{product_details.total_price}</span>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </section>
                                        </div>

                                        <aside className="ps-checkout__sidebar">
                                            <div className="ps-checkout-card ps-checkout-card--summary">
                                                <div className="ps-checkout-card__header">
                                                    <div>
                                                        <span className="ps-checkout-card__eyebrow">Payment summary</span>
                                                        <h3>Order total</h3>
                                                    </div>
                                                </div>

                                                <div className="ps-checkout-summary">
                                                    <div className="ps-checkout-summary__row">
                                                        <span className="ps-checkout-summary__label">Sub Total</span>
                                                        <strong className="ps-checkout-summary__value">&#8377; {totalBox.sub_total_cart_value}</strong>
                                                    </div>
                                                    <div className="ps-checkout-summary__row">
                                                        <span className="ps-checkout-summary__label">Delivery Charges</span>
                                                        <strong className="ps-checkout-summary__value">&#8377; {totalBox.total_delivery_charges}</strong>
                                                    </div>
                                                    <div className="ps-checkout-summary__row ps-checkout-summary__row--total">
                                                        <span className="ps-checkout-summary__label">Total</span>
                                                        <strong className="ps-checkout-summary__value ps-checkout-summary__value--total">&#8377; {totalBox.total_cart_value_formated}</strong>
                                                    </div>
                                                    <div className="ps-checkout-summary__field">
                                                        <label className="ps-checkout-summary__label" htmlFor="checkoutGstNumber">GST Number</label>
                                                        <input
                                                            id="checkoutGstNumber"
                                                            type="text"
                                                            name="gst_number"
                                                            className="form-control gstInputBox"
                                                            value={this.state.gst_number}
                                                            onChange={(event) => this.setState({ gst_number: event.target.value })}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="ps-checkout-card__actions ps-checkout-card__actions--summary">
                                                    {deliveryaddress !== '' ?
                                                        <button className="ps-btn ps-btn--sm ps-btn--warning ps-checkout-card__cta" onClick={() => this.openPayModal()}>
                                                            Continue with Payment
                                                        </button>
                                                        :
                                                        <button className="ps-btn ps-btn--sm ps-btn--disabled ps-checkout-card__cta" disabled>
                                                            Continue with Payment
                                                        </button>
                                                    }
                                                    {deliveryaddress === '' ? <p className="errorText">Please select delivery address</p> : null}
                                                </div>
                                            </div>
                                        </aside>
                                    </div>
                                ) : (
                                    <p>No record found</p>
                                )}
                            </div>
                        </div>

                        <NotificationContainer />
                    </div>
                </div>
            </div>
        );
    }
}

export default Checkout;
